import { createSlice } from '@reduxjs/toolkit';
import { getStatusMessage } from '../../utils/response-code-messages';
import { get } from 'lodash';
import Snackbar from '../../common/snackBar';

const page_name = 'maintenanceManagement';

interface MAINTENANCE_STATE_TYPES {
  isMaintenanceListLoading: boolean;
  isMaintenanceListHaveError: boolean;
  maintenancePlanData: Array<any>;
  maintenancePlanTotalCount: Number;
  maintenancePlanPageNumber: Number;
  maintenancePlanSearchItem: string;

  isActivityListLoading: boolean;
  isActivityListHaveError: boolean;
  activityListData: Array<any>;
  activityListTotalCount: Number;
  activityListPageNumber: Number;
  activitySearchItem: string;

  isMaintenanceHistoryLoading: boolean;
  isMaintenanceHistoryHaveError: boolean;
  maintenanceHistoryData: Array<any>;
  maintenanceHistoryTotalCount: Number;
  maintenanceHistoryPageNumber: Number;
  maintenanceHistorySearchItem: string;

  isActivityHistoryLoading: boolean;
  isActivityHistoryHaveError: boolean;
  activityHistoryData: Array<any>;
  activityHistoryTotalCount: Number;
  activityHistoryPageNumber: Number;
  activityHistorySearchItem: string;

  addActivityLoading: boolean;
  addActivityError: boolean;
  addActivitySuccess: boolean;

  updateActivityLoading: boolean;
  updateActivityError: boolean;
  updateActivitySuccess: boolean;

  activityData: any;
  activityDataLoading: boolean;
  activityDataRequestFailed: boolean;

  deleteActivityLoading: boolean;
  deleteActivityError: boolean;
  deleteActivitySuccess: boolean;

  addMaintenancePlanLoading: boolean;
  addMaintenancePlanError: boolean;
  addMaintenancePlanSuccess: boolean;

  singleMaintenancePlan: any;
  singleMaintenancePlanLoading: boolean;
  singleMaintenancePlanError: boolean;

  updateMaintenancePlanLoading: boolean;
  updateMaintenancePlanError: boolean;
  updateMaintenancePlanSuccess: boolean;

  downloadDocumentLoading: boolean;
  downloadDocumentError: boolean;

  deletePlanLoading: boolean;
  deletePlanError: boolean;
  deletePlanSuccess: boolean;

  engineers: any;
  engineersLoading: boolean;
  engineersRequestError: boolean;

  maintenanceName: string;

  isMaintenanceTaskListLoading: boolean;
  isMaintenanceTaskListHaveError: boolean;
  maintenanceTaskPlanData: Array<any>;
  maintenanceTaslPlanCounts: {};
  maintenanceTaskPlanTotalCount: Number;
  maintenanceTaskPlanPageNumber: Number;
  maintenanceTaskPlanSearchItem: string;

  isCheckMachinesLoading: boolean;
  checkMachinePlanData: any;
}

const initialState: MAINTENANCE_STATE_TYPES = {
  isMaintenanceListLoading: false,
  isMaintenanceListHaveError: false,
  maintenancePlanData: [],
  maintenancePlanTotalCount: 0,
  maintenancePlanPageNumber: 0,
  maintenancePlanSearchItem: '',
  isActivityListLoading: false,
  isActivityListHaveError: false,
  activityListData: [],
  activityListTotalCount: 0,
  activityListPageNumber: 0,
  activitySearchItem: '',
  isMaintenanceHistoryLoading: false,
  isMaintenanceHistoryHaveError: false,
  maintenanceHistoryData: [],
  maintenanceHistoryTotalCount: 0,
  maintenanceHistoryPageNumber: 0,
  maintenanceHistorySearchItem: '',
  isActivityHistoryLoading: false,
  isActivityHistoryHaveError: false,
  activityHistoryData: [],
  activityHistoryTotalCount: 0,
  activityHistoryPageNumber: 0,
  activityHistorySearchItem: '',
  activityData: {},
  activityDataLoading: false,
  activityDataRequestFailed: false,
  addActivityLoading: false,
  addActivityError: false,
  addActivitySuccess: false,
  updateActivityLoading: false,
  updateActivityError: false,
  updateActivitySuccess: false,
  deleteActivityLoading: false,
  deleteActivityError: false,
  deleteActivitySuccess: false,

  addMaintenancePlanLoading: false,
  addMaintenancePlanSuccess: false,
  addMaintenancePlanError: false,

  singleMaintenancePlan: {},
  singleMaintenancePlanLoading: false,
  singleMaintenancePlanError: false,

  updateMaintenancePlanLoading: false,
  updateMaintenancePlanError: false,
  updateMaintenancePlanSuccess: false,

  downloadDocumentLoading: false,
  downloadDocumentError: false,

  deletePlanLoading: false,
  deletePlanError: false,
  deletePlanSuccess: false,

  engineers: [],
  engineersLoading: false,
  engineersRequestError: false,

  maintenanceName: '',


  isMaintenanceTaskListLoading: false,
  isMaintenanceTaskListHaveError: false,
  maintenanceTaskPlanData: [],
  maintenanceTaslPlanCounts: {},
  maintenanceTaskPlanTotalCount: 0,
  maintenanceTaskPlanPageNumber: 0,
  maintenanceTaskPlanSearchItem: '',
  isCheckMachinesLoading: false,
  checkMachinePlanData: {}
};

const maintenanceManagementReducer = createSlice({
  name: page_name,
  initialState: initialState,
  reducers: {
    getMaintenaceListRequest: (state, action: any) => {
      state.isMaintenanceListLoading = true;
    },
    getMaintenaceListResponse: (state, action: any) => {
      state.isMaintenanceListLoading = false;
      state.isMaintenanceListHaveError = false;
      state.maintenancePlanData = get(action, 'payload.data', []);
      state.maintenancePlanTotalCount = get(action, 'payload.total_count', 0);
      state.maintenancePlanPageNumber = get(action, 'payload.page', 1);
      // state.maintenancePlanData = action.payload;
      // console.log(action.payload);
      // if (state.maintenancePlanSearchItem === get(action, 'payload.search_item', '')) {
      //   state.maintenancePlanData = get(action, 'payload.data', []);
      //   state.maintenancePlanTotalCount = get(action, 'payload.total_count', 0);
      //   state.maintenancePlanPageNumber = get(action, 'payload.page', 1);
      // }
    },
    getMaintenanceListFailed: (state, action: any) => {
      state.isMaintenanceListLoading = false;
      state.isMaintenanceListHaveError = true;
      state.maintenancePlanData = [];
    },
    getActivityListRequest: (state, action) => {
      state.isActivityListLoading = true;
      state.isActivityListHaveError = false;
    },
    getActivityListResponse: (state, action) => {
      state.isActivityListLoading = false;
      state.isActivityListHaveError = false;
      state.activityListData = get(action, 'payload.data', []);
      state.activityListTotalCount = get(action, 'payload.total_count', 0);
      state.activityListPageNumber = get(action, 'payload.page', 1);
      // if (state.activitySearchItem === get(action, 'payload.search_item', '')) {
      //   state.activityListData = get(action, 'payload.data', []);
      //   state.activityListTotalCount = get(action, 'payload.total_count', 0);
      //   state.activityListPageNumber = get(action, 'payload.page', 1);
      // }
    },
    getActivityListFailed: (state, action: any) => {
      state.isActivityListLoading = false;
      state.isActivityListHaveError = true;
      state.activityListData = [];
    },

    getActivityRequest: (state, action) => {
      state.activityDataLoading = true;
      state.activityDataRequestFailed = false;
    },
    getActivityResponse: (state, action) => {
      state.activityDataLoading = false;
      state.activityData = action.payload;
    },
    getActivityFailed: (state, action: any) => {
      state.activityDataLoading = false;
      state.activityDataRequestFailed = true;
    },

    getMaintenanceHistoryRequest: (state, action) => {
      state.isMaintenanceHistoryLoading = true;
      state.maintenanceName = '';
    },
    getMaintenanceHistoryResponse: (state, action) => {
      state.isMaintenanceHistoryLoading = false;
      state.isMaintenanceHistoryHaveError = false;
      state.maintenanceName = get(action, 'payload.maintenance_name', '');
      state.maintenanceHistoryData = get(action, 'payload.data', []);
      state.maintenanceHistoryTotalCount = get(action, 'payload.total_count', 0);
      state.maintenanceHistoryPageNumber = get(action, 'payload.page', 1);
    },
    getMaintenanceHistoryFailed: (state, action: any) => {
      state.isMaintenanceHistoryLoading = false;
      state.isMaintenanceHistoryHaveError = true;
      state.maintenanceHistoryData = [];
    },

    getActivityHistoryRequest: (state, action) => {
      state.isActivityHistoryLoading = true;
      state.isMaintenanceHistoryHaveError = false;
    },
    getActivityHistoryResponse: (state, action) => {
      state.isActivityHistoryLoading = false;
      state.isActivityHistoryHaveError = false;
      // state.activityHistoryData = action.payload;
      // if (state.activitySearchItem === get(action, 'payload.search_item', '')) {
      state.maintenanceName = get(action, 'payload.maintenance_name', '');
      state.activityHistoryData = get(action, 'payload.data', []);
      state.activityHistoryTotalCount = get(action, 'payload.total_count', 0);
      state.activityHistoryPageNumber = get(action, 'payload.page', 1);
      // }
    },
    getActivityHistoryFailed: (state, action: any) => {
      state.isActivityHistoryLoading = false;
      state.isActivityHistoryHaveError = true;
      state.maintenanceHistoryData = [];
    },


    addActivityRequest: (state, action) => {
      state.addActivityLoading = true;
      state.addActivitySuccess = false;
    },
    addActivityResponse: (state, action) => {
      state.addActivityLoading = false;
      state.addActivityError = false;
      state.addActivitySuccess = true;
    },
    addActivityRequestFailed: (state, action: any) => {
      state.addActivityLoading = false;
      state.addActivityError = true;
      Snackbar.error(action.payload ?? 'Something went wrong!');
    },
    updateActivityRequest: (state, action) => {
      state.updateActivityLoading = true;
      state.updateActivitySuccess = false;
      state.updateActivityError = false;
    },
    updateActivityResponse: (state, action) => {
      state.updateActivityLoading = false;
      state.updateActivitySuccess = true;
    },
    updateActivityRequestFailed: (state, action: any) => {
      state.updateActivityLoading = false;
      state.updateActivityError = true;
      Snackbar.error(action.payload ?? 'Something went wrong!');
    },
    deleteActivityRequest: (state, action) => {
      state.deleteActivityLoading = true;
      state.deleteActivityError = false;
      state.deleteActivitySuccess = false;
    },
    deleteActivityResponse: (state, action) => {
      state.deleteActivityLoading = false;
      state.deleteActivitySuccess = true;
      Snackbar.success('Checklist has been successfully deleted.');
    },
    deleteActivityRequestFailed: (state, action: any) => {
      state.deleteActivityLoading = false;
      state.deleteActivityError = true;
      Snackbar.error(action.payload.data ?? 'Something went wrong!');
    },
    addMaintenancePlanRequest: (state, action) => {
      state.addMaintenancePlanLoading = true;
      state.addMaintenancePlanError = false;
    },
    addMaintenancePlanResponse: (state, action) => {
      state.addMaintenancePlanLoading = false;
      state.addMaintenancePlanSuccess = true;
    },
    addMaintenancePlanRequestFailed: (state, action) => {
      state.addMaintenancePlanLoading = false;
      state.addMaintenancePlanError = true;
      Snackbar.error(action.payload.data ?? 'Something went wrong!');
    },
    getMaintenancePlanRequest: (state, action) => {
      state.singleMaintenancePlanLoading = true;
      state.singleMaintenancePlanError = false;
    },
    getMaintenancePlanResponse: (state, action) => {
      state.singleMaintenancePlanLoading = false;
      state.singleMaintenancePlan = action.payload;
    },
    getMaintenancePlanRequestFailed: (state, action: any) => {
      state.singleMaintenancePlanLoading = false;
      state.singleMaintenancePlanError = true;
    },
    updateMaintenancePlanRequest: (state, action) => {
      state.updateMaintenancePlanLoading = true;
      state.updateMaintenancePlanError = false;
      state.updateMaintenancePlanSuccess = false;
    },
    updateMaintenancePlanResponse: (state, action) => {
      state.updateMaintenancePlanLoading = false;
      state.updateMaintenancePlanSuccess = true;
    },
    updateMaintenancePlanRequestFailed: (state, action: any) => {
      state.updateMaintenancePlanLoading = false;
      state.updateMaintenancePlanError = true;
      Snackbar.error(action.payload ?? 'Something went wrong!');
    },
    downloadDocumentRequest: (state, action) => {
      state.downloadDocumentLoading = true;
      state.downloadDocumentError = false;
    },
    downloadDocumentResponse: (state, action) => {
      state.downloadDocumentLoading = false;
      Snackbar.success('Downloading...!');
    },
    downloadDocumentRequestFailed: (state, action: any) => {
      state.downloadDocumentLoading = false;
      state.downloadDocumentError = true;
      Snackbar.error(action.payload ?? 'Something went wrong!');
    },
    resetActivityState: (state) => {
      state.addActivitySuccess = false;
      state.updateActivitySuccess = false;
      state.deleteActivitySuccess = false;
      state.activityData = {};
    },
    resetMaintenancePlanState: (state) => {
      state.addMaintenancePlanSuccess = false;
      state.updateMaintenancePlanSuccess = false;
      state.checkMachinePlanData = {};
      state.maintenanceTaskPlanData = [];
      state.maintenanceTaskPlanPageNumber = 1;
      state.maintenanceTaskPlanTotalCount = 0;
      state.maintenanceTaslPlanCounts = {};
    },
    onSearchForActivityItem: (state, action: any) => {
      state.activitySearchItem = action.payload;
    },
    onSearchForMaintenanceItem: (state, action: any) => {
      state.maintenancePlanSearchItem = action.payload;
    },
    deletePlanRequest: (state, action) => {
      state.deletePlanLoading = true;
      state.deletePlanError = false;
      state.deletePlanSuccess = false;
    },
    deletePlanResponse: (state, action) => {
      state.deletePlanLoading = false;
      state.deletePlanSuccess = true;
      Snackbar.success('Plan has been successfully deleted.');
    },
    deletePlanRequestFailed: (state, action: any) => {
      state.deletePlanLoading = false;
      state.deletePlanError = true;
      Snackbar.error(action.payload);
    },
    getEngineersRequest: (state, action) => {
      state.engineersLoading = true;
      state.engineersRequestError = false;
    },
    getEngineersResponse: (state, action) => {
      state.engineersLoading = false;
      state.engineers = get(action, 'payload.data', []);
    },
    getEngineersRequestFailed: (state, action: any) => {
      state.engineersLoading = false;
      state.engineersRequestError = true;
    },
    getMaintenaceTaskRequest: (state, action: any) => {
      state.isMaintenanceTaskListLoading = true;
    },
    getMaintenaceTaskResponse: (state, action: any) => {
      state.isMaintenanceTaskListLoading = false;
      state.isMaintenanceTaskListHaveError = false;
      state.maintenanceTaskPlanData = get(action, 'payload.data', []);
      state.maintenanceTaskPlanTotalCount = get(action, 'payload.total_count', 0);
      state.maintenanceTaskPlanPageNumber = get(action, 'payload.page', 1);
      state.maintenanceTaslPlanCounts = get(action, 'payload.counts', {});
    },
    getMaintenanceTaskFailed: (state, action: any) => {
      state.isMaintenanceTaskListLoading = false;
      state.isMaintenanceTaskListHaveError = true;
      state.maintenanceTaskPlanData = [];
      state.maintenanceTaslPlanCounts = {};
    },
    checkMachineRequest: (state, action: any) => {
      state.isCheckMachinesLoading = true;
    },
    checkMachineResponse: (state, action: any) => {
      state.isCheckMachinesLoading = false;
      state.checkMachinePlanData = get(action, 'payload.data', {});
    },
    checkMachineFailed: (state, action: any) => {
      state.isCheckMachinesLoading = false;
      state.checkMachinePlanData = {};
    },
  },
});

export const maintenanceManagementActions = maintenanceManagementReducer.actions;
export default maintenanceManagementReducer;
